
<table>
    <tr>
        <td class="label">Order #</td>
        <td class="label">{{order?.order_number}}</td>
    </tr>
    <tr>
        <td class="label">Created:</td>
        <td>{{order?.created | date:'short'}}</td>
    </tr>
    <tr>
        <td class="label">Status:</td>
        <td>{{order?.status}}</td>
    </tr>
</table>

<table *ngFor="let item of order?.items; index as i">
    <tr>
        <td class="shipment">Shipment {{order.items.length > 1? i+1 : ''}}:</td>
    </tr>
    <tr>
        <td></td>
        <td class="label">Contents:</td>
        <td>{{item.count}} x {{item.name}}</td>
    </tr>
    <tr>
        <td></td>
        <td class="label">Status:</td>
        <td>{{item.status}}</td>
    </tr>
    <tr>
        <td></td>
        <td class="label">Tracking #</td>
        <td><rr-fedex-tracking [tracking_number]="item.tracking_number"></rr-fedex-tracking></td>
    </tr>
    <tr>
        <td></td>
        <td class="label">Shipping Label:</td>
        <td>
            <span class="link" (click)="viewShippingLabel(item)">View</span>
            <mat-spinner [diameter]="15" *ngIf="loading && item==currentItem"></mat-spinner>
        </td>
    </tr>
</table>

<br/>

<table>
    <tr *ngFor="let item of order?.items">
        <td class="label">{{item.name}}</td>
        <td class="count">x {{item.count}}</td>
        <td class="amount">{{item.unit_price | currency}}</td>
    </tr>
    <tr>
        <td class="label">Subtotal:</td>
        <td></td>
        <td class="amount">{{order?.subtotal | currency}}</td>
    </tr>
    <tr>
        <td class="label">Shipping:</td>
        <td></td>
        <td class="amount">{{order?.shipping | currency}}</td>
    </tr>
    <tr>
        <td class="label">Tax:</td>
        <td></td>
        <td class="amount">{{order?.tax | currency}}</td>
    </tr>
    <tr>
        <td class="label">Discount:</td>
        <td></td>
        <td class="amount">{{-order?.discount | currency}}</td>
    </tr>
    <tr>
        <td class="label total">Total:</td>
        <td></td>
        <td class="total amount">{{order?.total | currency}}</td>
    </tr>
</table>

<div *ngIf="order?.history?.length > 1">
    <br/>
    <div class="history">History:</div>
    <table>
        <tr *ngFor="let event of order.history">
            <td class="label">Status:</td>
            <td>{{event.status}}</td>
            <td>{{event.created | date:'short'}}</td>
        </tr>
    </table>
</div>


